import { render } from "./WCHeader.vue?vue&type=template&id=099766b2&scoped=true"
import script from "./WCHeader.vue?vue&type=script&lang=js"
export * from "./WCHeader.vue?vue&type=script&lang=js"

import "./WCHeader.vue?vue&type=style&index=0&id=099766b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099766b2"]])

export default __exports__